// extracted by mini-css-extract-plugin
export var nav = "resources-module--nav--3SPLY";
export var cards = "resources-module--cards--2WTXh";
export var hero = "resources-module--hero--h5aXp";
export var pager = "resources-module--pager--6AY3g";
export var postCard = "resources-module--post-card--Ip9m4";
export var postLink = "resources-module--post-link--3G5rh";
export var cardImage = "resources-module--card-image--2mnfy";
export var cardType = "resources-module--card-type--2qZll";
export var grey = "resources-module--grey--3FZi4";
export var pagerSet = "resources-module--pager-set--2Gbs3";